import { Fragment } from "react";
import { Link } from "react-router-dom";
import type { AssetKind } from "../api/types";

const SECOND: Record<AssetKind, { text: string; to: string }> = {
  shape: { text: "Objects", to: "/assets?kind=object" },
  variant: { text: "Objects", to: "/assets?kind=object" },
  material: { text: "Surfaces", to: "/assets?kind=material" },
  skin: { text: "Artwork", to: "/assets?kind=skin" },
  figure: { text: "People", to: "/assets?kind=figure" },
  action: { text: "People", to: "/assets?kind=figure" },
};

/** Tall enough for a thumb on a phone. */
const LINK = "inline-flex min-h-[44px] items-center underline sm:min-h-0";

/** The query string the grid was left with (`AssetsPage` stores it), so the
 *  way back opens the grid as the user left it. */
function storedFilters(): string {
  try {
    const stored = sessionStorage.getItem("assets.back") ?? "";
    return stored.startsWith("?") ? stored : "";
  } catch {
    return "";
  }
}

/** A trail of places, the last of which is this page. */
export function Trail({
  steps,
  here,
}: {
  steps: { text: string; to: string }[];
  here: string;
}): JSX.Element {
  return (
    <nav
      aria-label="Breadcrumb"
      className="mb-2 flex flex-wrap items-center gap-x-2 text-sm text-slate-600 sm:mb-4"
    >
      {steps.map((step) => (
        <Fragment key={step.to}>
          <Link to={step.to} className={LINK}>
            {step.text}
          </Link>
          <span aria-hidden="true">/</span>
        </Fragment>
      ))}
      <span aria-current="page" className="min-w-0 break-words text-slate-800">
        {here}
      </span>
    </nav>
  );
}

/** Where an inspector page sits: the 3D library, the kind, the name. */
export function Breadcrumb({
  kind,
  name,
}: {
  kind: AssetKind;
  name: string;
}): JSX.Element {
  const second = SECOND[kind];
  const first = { text: "Objects", to: "/assets" + storedFilters() };
  // The section and the kind of an object are both "Objects" since
  // 2026-10-14: one crumb, the one that leads back to the grid as it was.
  return (
    <Trail
      steps={second.text === first.text ? [first] : [first, second]}
      here={name}
    />
  );
}
